var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M24 4.5c.828 0 1.5.595 1.5 1.329V34.17c0 .734-.672 1.329-1.5 1.329s-1.5-.595-1.5-1.329V5.83c0-.734.672-1.329 1.5-1.329zm-12 4a1.5 1.5 0 0 1 1.5 1.5v20a1.5 1.5 0 0 1-3 0V10A1.5 1.5 0 0 1 12 8.5zm4 2a1.5 1.5 0 0 1 1.5 1.5v16a1.5 1.5 0 0 1-3 0V12a1.5 1.5 0 0 1 1.5-1.5zm12 0a1.5 1.5 0 0 1 1.5 1.5v16a1.5 1.5 0 0 1-3 0V12a1.5 1.5 0 0 1 1.5-1.5zm-20 2A1.5 1.5 0 0 1 9.5 14v12a1.5 1.5 0 0 1-3 0V14A1.5 1.5 0 0 1 8 12.5zm24 0a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-3 0V14a1.5 1.5 0 0 1 1.5-1.5zm-28 4A1.5 1.5 0 0 1 5.5 18v4a1.5 1.5 0 0 1-3 0v-4A1.5 1.5 0 0 1 4 16.5zm16 0a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-3 0v-4a1.5 1.5 0 0 1 1.5-1.5zm16 0a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-3 0v-4a1.5 1.5 0 0 1 1.5-1.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wave.fd65b670ef8bfc47e515e3d8e5f7a493.svg";